import axiosClient from "./axiosClient";
import { IClientRegisterLeaderboard, IGetLeaderboardDetail } from "@interfaces";

export const leaderboardAPI = {
    clientRegisterLeaderboard: (values: IClientRegisterLeaderboard) => {
        const url = "leaderboard/join-leaderboard";
        return axiosClient.post(url, values);
    },
    getleaderboard: (params: string) => {
        const url = "leaderboard/";
        return axiosClient.get(url + params);
    },
    getleaderboardList: (params: string) => {
        const url = "leaderboard/user-leaderboard/";
        return axiosClient.get(url + params);
    },
    getleaderboardDetail: (values: IGetLeaderboardDetail) => {
        const url = "leaderboard/user-details-leaderboard";
        return axiosClient.post(url, values);
    },
    getleaderboardOwn: (params: string) => {
        const url = "leaderboard/own-user-leaderboard/";
        return axiosClient.get(url + params);
    },
};
